import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";
import { GetBCForSalesOrderDto } from "../models/orders/getBCForSalesOrderDto";

@Injectable({
  providedIn: "root",
})
export class SamplepoListingService {
  private userSupportManagementBaseURL = environment.baseUrl + "/UserSupport";

  constructor(private _http: HttpClient) {}

  getAllWhoISupport(): Observable<GenericResponseDto<GetBCForSalesOrderDto[]>> {
    return this._http.get<GenericResponseDto<GetBCForSalesOrderDto[]>>(
      this.userSupportManagementBaseURL + `/GetAllWhoISupport`
    );
  }

  getAllWhoISupportIfAdminGetAllBc(): Observable<
    GenericResponseDto<GetBCForSalesOrderDto[]>
  > {
    return this._http.get<GenericResponseDto<GetBCForSalesOrderDto[]>>(
      this.userSupportManagementBaseURL + `/GetAllWhoISupportIfAdminGetAllBc`
    );
  }
}
